/**
 * Painel Conteudo do documento (SPEC-20261102-1956): coluna propria a esquerda
 * do texto, com largura ajustavel pela alca. Ele nunca fica por baixo do texto:
 * a largura efetiva para antes de o texto ficar mais estreito que TEXTO_MINIMO.
 */

/** Limites da largura ajustavel pela alca. */
export const TOC_MIN = 140;
export const TOC_MAX = 380;
/** O texto nunca fica mais estreito que isto por causa do Conteudo. */
export const TEXTO_MINIMO = 560;
/** Respiro lateral do miolo (24 de cada lado) + distancia Conteudo-texto (28). */
const FOLGAS_DO_MIOLO = 48 + 28;

/** Maior largura do Conteudo que ainda deixa o texto com TEXTO_MINIMO (abaixo de TOC_MIN, ele some). */
export function larguraMaximaDoConteudo(larguraDoMiolo: number): number {
  return Math.min(TOC_MAX, larguraDoMiolo - FOLGAS_DO_MIOLO - TEXTO_MINIMO);
}
